import { useSyncExternalStore } from 'react';

const CONSULTA = '(min-width: 1024px)';

let consulta: MediaQueryList | null = null;

function medio(): MediaQueryList {
  consulta ??= window.matchMedia(CONSULTA);
  return consulta;
}

function suscribir(alCambiar: () => void): () => void {
  const m = medio();
  m.addEventListener('change', alCambiar);
  return () => m.removeEventListener('change', alCambiar);
}

export function useEsEscritorio(): boolean {
  return useSyncExternalStore(
    suscribir,
    () => medio().matches,

    () => true,
  );
}
